export default __webpack_public_path__ + "static/media/Astro_Scorpio_White.955e9b5d.png";